<template>
  <div class="device-block-page">
    <div class="container">
      <div class="chart-block">
        <!-- <img src="/static/images/device/gzsjhz.png" class="titl"> -->
        <div class="item">
          <div class="chart-box">
            <v-chart :options="options_gzsjhz" />
            <div class="tab-switch">
              <span v-for="item in tabData" :class="[{'current': tabKey==item}]" v-text="item" @click="tabSwitch(item)"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts/lib/echarts'
export default{
  data() {
    let tabData = ['日', '周', '月'];
    return {
      tabData: tabData,
      tabKey: tabData[0],
      gzsjhzList: [],
      options_gzsjhz: {},
    }
  },
  mounted() {
    //定义全局方法
    window.gbfc_resetData = this.resetData;
    //初始化
    this.$initPage(this);
  },
  methods: {
    resetData() {
      //故障汇总
      this.getGzsjhzList();
    },
    tabSwitch(item) {
      console.log(item)
      this.tabKey = item;
      this.getGzsjhzList();
    },
    getGzsjhzList() {
      let self = this;
      let todayTime = (new Date(new Date().setHours(0, 0, 0, 0)).getTime()) / 1000;  //今天0点时间戳毫秒
      let startTime = this.$formatDateTime(todayTime - 3600*24, 'yyyy-MM-dd hh:mm:ss');
      let endTime = this.$formatDateTime(todayTime, 'yyyy-MM-dd hh:mm:ss');

      if(this.tabKey == '日') {
        //
      } else if(this.tabKey == '周') {
        startTime = this.$formatDateTime(todayTime - 3600*24*7, 'yyyy-MM-dd hh:mm:ss');
      } else if(this.tabKey == '月') {
        startTime = this.$formatDateTime(todayTime - 3600*24*30, 'yyyy-MM-dd hh:mm:ss');
      }
      let url = '/InteractAPI/Distribution_AE_Stn_Duration/'+window.PYKScadaCode+'/'+startTime+'/'+endTime+'/-1';
      this.$handleRequest(window.ApiHost2+url, {}, 'get', function(res) {  //success
        self.gzsjhzList = res;
        self.setOptionsGzsjhz();
      }, function(res) {  //fail
        console.log('fail', res);
      });
    },
    setOptionsGzsjhz() {
      let colors = this.$charts.colors.style_2;
      let chartsConf = this.$charts[window.CurrentTheme];
      let sdata = [];
      let legendData = [];

      this.gzsjhzList.forEach( function(l, li) {
        legendData.push(l.StationName);
        let value = Math.round(l.TotalDuration_Stn/60*100)/100;
        let color = colors[li][1];
        let tmp = {
          value: value,
          name: l.StationName,
          label: {
            color: chartsConf.series.color,
            fontSize: 24
          },
          itemStyle:{
            normal:{
              color: color,
            }
          }
        };
        sdata.push(tmp);
      });
      this.options_gzsjhz = {
        tooltip : {
            trigger: 'item',
            formatter: "{b} : {c}min ({d}%)",
            textStyle: {
              fontSize: 24
            }
        },
        legend: {
            x : 'center',
            y : 'bottom',
            textStyle: {
              color: chartsConf.legend.color,
              fontSize: 24
            },
            data: legendData
        },
        //calculable : true,
        series : [
            {
              type:'pie',
              radius: ['38%', '55%'],
              center : ['55%', '40%'],
              //roseType : 'area',
              data: sdata
            }
        ]
      };
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/xiayan/device/DeviceMaintainFaultTime.vue